export const ArrayHelper = (() => {
  function insert(arr = [], idx, newItem) {
    return [...arr.slice(0, idx), newItem, ...arr.slice(idx)];
  }

  const isPropValuesEqual = (subject, target, propNames) =>
    propNames.every((propName) => subject[propName] === target[propName]);

  function getUniqueItemsByProperties(items, propNames) {
    return items.filter(
      (item, index, array) =>
        index ===
        array.findIndex((foundItem) =>
          isPropValuesEqual(foundItem, item, propNames)
        )
    );
  }

  
  const removeObjectsDuplicated = (array, propstoFilter) => {
    const newArray = [];
    const usedProperties = [];

    array.forEach((obj) => {
      let propertyString = "";

      propstoFilter.forEach((prop) => {
        propertyString += obj[prop] + "-";
      });

      if (!usedProperties.includes(propertyString)) {
        newArray.push(obj);
        usedProperties.push(propertyString);
      }
    });

    return newArray;
  };

  return {
    insert,
    getUniqueItemsByProperties,
    removeObjectsDuplicated,
  };
})();
